<template>
  <DetailsRole :roleId="roleId" />
  <CoursesRole :roleId="roleId" />
  <UsersRole :roleId="roleId" />
</template>

<script>
import DetailsRole from '@/components/roles/roles/DetailsRole.vue'
import CoursesRole from '@/components/roles/courses/CoursesRole.vue'
import UsersRole from '@/components/roles/users/UsersRole.vue'

export default {
  name: 'RoleDetails',

  components: {
    DetailsRole,
    CoursesRole,
    UsersRole,
  },

  data() {
    return {
      roleId: this.$route.params.roleId,
    }
  },
}
</script>
